import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { RFP_PAYMENT_OPTIONS, RFP_PAYMENT_OPTION_TWO_PERCENT, } from '@/utils/constants/rfp/paymentOption';
/**
 * 支払い方法の説明文表示コンポーネント
 * @description テキストのスタイルに関しては親要素で付与する
 * @param props
 * @returns
 */
export const RfpProOfferPaymentOptionText = (props) => {
    const { isShort = false, isWrap = false, paymentOption } = props;
    const targetOption = useMemo(() => {
        const matchOption = RFP_PAYMENT_OPTIONS.find((option) => option.value === paymentOption);
        return matchOption
            ? Object.assign(Object.assign({}, matchOption), { percent: matchOption.feeRate * 100 }) : null;
    }, [paymentOption]);
    // 支払い方法に一致するものがない場合（ない想定）
    if (!targetOption) {
        return null;
    }
    // 短い表示の場合
    if (isShort) {
        // eslint-disable-next-line react/jsx-no-useless-fragment
        return _jsx(_Fragment, { children: targetOption.label });
    }
    const { feeBase, percent, timing, value } = targetOption;
    // 通常表示
    return (_jsxs(_Fragment, { children: [`お支払い金額は、${timing}際に、`, isWrap && _jsx("br", { className: 'inline sm:hidden' }), `${feeBase}（税抜き）の${percent}%を`, isWrap && _jsx("br", { className: 'inline sm:hidden' }), "\u3054\u8ACB\u6C42\u3055\u305B\u3066\u9802\u304D\u307E\u3059\u3002", value === RFP_PAYMENT_OPTION_TWO_PERCENT.value && (_jsxs(_Fragment, { children: [isWrap && _jsx("br", {}), "\u203B\u4E88\u7B97\u91D1\u984D\u304COPEN\u306E\u5834\u5408\u306F", isWrap && _jsx("br", { className: 'inline sm:hidden' }), "\u3054\u63D0\u6848\u91D1\u984D\u304C\u57FA\u6E96\u3068\u306A\u308A\u307E\u3059"] }))] }));
};
